import React from 'react';
import ThermalInvoice from './ThermalInvoice';

const InvoiceExample: React.FC = () => {
  // بيانات تجريبية للفاتورة مطابقة لبنية SuccessScreen
  const sampleInvoiceData = {
    orderNumber: '9028',
    created_at: '2020-05-27T09:27:53.000Z',
    customerName: 'Malicious Guest',
    customerPhone: '0570577722',
    branch: 'الفرع الرئيسي',
    paymentMethod: 'الدفع الإلكتروني',
    items: [
      {
        name: 'منتج لحوم',
        quantity: 1,
        price: 9.0,
        meals: [
          {
            name: 'منتج لحوم',
            additionals: [
              { name: 'خس' },
              { name: 'طماطم' }
            ]
          }
        ]
      },
      {
        name: 'شاورما',
        quantity: 2,
        price: 9.0,
        meals: [
          {
            name: 'شاورما',
            additionals: []
          }
        ]
      },
      {
        name: 'فول',
        quantity: 2,
        price: 45.0,
        meals: [
          {
            name: 'فول',
            additionals: []
          }
        ]
      }
    ],
    subtotal: 84.0,
    tablePrice: 0,
    deliveryPrice: 0,
    discount: 0,
    taxValue: 12.6,
    taxPercentage: '%15',
    totalPrice: 84.0
  };

  return <ThermalInvoice invoiceData={sampleInvoiceData} />;
};

export default InvoiceExample;
